var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTytul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1285 74.98",
    style: {
      enableBackground: "new 0 0 1285 74.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3170CE;}\n\t.st1{fill:#F77284;}\n\t.st2{fill:#FFD600;}\n\t.st3{fill:#141413;}\n\t.st4{fill:#2E71CE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.24,0l3.79,6.82l-11.39,20.45H97.77l-3.8-6.82l7.6-13.63H87.94l-8.37,15.19l6.91,12.17h53.17l-18.9,33.99 l3.8,6.82H3.8L0,68.17L15.29,40.9h46.06l3.8,6.82L53.66,68.17h13.63l12.27-21.91l-6.91-12.17H18.99L34.28,6.82L30.48,0H151.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M285.89,0l3.79,6.82l-34.28,61.35l3.8,6.82h-61.16l19.09-34.08h-13.63l-19.09,34.08h-45.96l-3.8-6.82 l34.28-61.35L165.14,0H285.89z M220.94,34.08l15.19-27.27h-13.63l-15.19,27.27H220.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M340.79,0l3.5,6.82v56l31.26-56L371.76,0h61.16l3.8,6.82l-34.28,61.35l3.8,6.82h-45.97l-3.8-6.82l22.79-40.9 l-3.8-6.82l-30.38,54.53h-37.69l-3.8-6.82V20.45l-30.48,54.53l-3.8-6.82l34.28-61.35L299.79,0H340.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M416.34,68.17l34.28-61.35L446.82,0h120.76l3.8,6.82L537.1,68.17l3.79,6.82H420.14L416.34,68.17z M477.5,68.17 h13.63l-3.8-6.82l26.68-47.72l-3.8-6.82h-13.63l3.79,6.82L473.7,61.35L477.5,68.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M702.24,0l3.8,6.82l-11.39,20.45h-45.87l-3.8-6.82l7.6-13.63h-13.63l-8.37,15.19l6.91,12.17h53.17 l-18.89,33.99l3.79,6.82H554.8l-3.8-6.82l15.29-27.27h46.06l3.8,6.82l-11.49,20.45h13.63l12.27-21.91l-6.91-12.17h-53.66 l15.29-27.27L581.48,0H702.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M810.6,0l3.8,6.82h-27.27l-34.28,61.35l3.8,6.82h-53.56l-3.8-6.82l34.28-61.35h-13.63L716.14,0H810.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M885.64,0l-38.08,68.17h13.63L899.28,0h45.97l3.79,6.82l-34.28,61.35l3.8,6.82H797.81l-3.8-6.82l34.28-61.35 L824.49,0H885.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1056.92,0L1080,13.63l-22.88,40.9l-28.05,20.45h-96.6l-3.8-6.82l34.28-61.35L959.15,0H1056.92z M989.92,68.17 h13.63l-3.8-6.82l26.68-47.72l-3.8-6.82h-13.63l3.8,6.82l-26.68,47.72L989.92,68.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1093.02,13.63h53.56l-30.48,54.53l3.8,6.82h-53.56l-3.8-6.82L1093.02,13.63z M1146.58,0l3.8,6.82h-53.56 l-3.8-6.82H1146.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1129.97,68.17l34.28-61.35l-3.8-6.82h120.76l3.79,6.82l-34.28,61.35l3.8,6.82h-120.75L1129.97,68.17z  M1191.12,68.17h13.63l-3.8-6.82l26.68-47.72l-3.8-6.82h-13.63l3.8,6.82l-26.68,47.72L1191.12,68.17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTytul);
export default __webpack_public_path__ + "static/media/tytul.26b970df425c174abd2137da9b7b2376.svg";
export { ForwardRef as ReactComponent };